import type { SVGProps } from 'react';

export function BlobOrigami(props: Partial<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 360 351"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeMiterlimit: 10 }}
      {...props}
    >
      <path
        d="M348.996,179.823l0.183,4.128l1.78,-1.202l-0.144,5.402l4.43,-8.569l-5.379,1.451l-0.87,-1.21Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M340.144,175.556l0.365,8.256l3.561,-2.404l-0.289,10.803l8.861,-17.137l-10.758,2.902l-1.74,-2.42Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M348.996,179.823l0.183,4.128l1.78,-1.202l-0.144,5.402l4.43,-8.569l-5.379,1.451l-0.87,-1.21Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M340.144,175.556l0.365,8.256l3.561,-2.404l-0.289,10.803l8.861,-17.137l-10.758,2.902l-1.74,-2.42Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M331.292,171.289l0.548,12.384l5.341,-3.605l-0.433,16.204l13.292,-25.706l-16.139,4.353l-2.609,-3.63Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M322.44,167.021l0.731,16.513l7.121,-4.807l-0.578,21.606l17.723,-34.275l-21.518,5.804l-3.479,-4.841Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M313.588,162.754l0.914,20.641l8.901,-6.009l-0.722,27.008l22.153,-42.844l-26.897,7.255l-4.349,-6.051Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M304.736,158.487l1.096,24.769l10.682,-7.211l-0.866,32.409l26.584,-51.412l-32.277,8.706l-5.219,-7.261Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M295.884,154.22l1.279,28.897l12.462,-8.413l-1.011,37.811l31.015,-59.981l-37.656,10.157l-6.089,-8.471Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M287.032,149.953l1.462,33.024l14.242,-9.614l-1.155,43.213l35.445,-68.55l-43.036,11.608l-6.958,-9.681Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M278.18,145.686l1.645,37.152l16.022,-10.815l-1.299,48.613l39.875,-77.118l-48.415,13.058l-7.828,-10.89Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M269.328,141.419l1.828,41.28l17.802,-12.017l-1.444,54.015l44.307,-85.687l-53.795,14.509l-8.698,-12.1Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M260.476,137.152l2.01,45.408l19.583,-13.219l-1.588,59.417l48.737,-94.256l-59.174,15.96l-9.568,-13.31Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M251.624,132.884l2.193,49.537l21.364,-14.421l-1.733,64.818l53.167,-102.824l-64.553,17.411l-10.438,-14.521Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M242.772,128.617l2.376,53.665l23.144,-15.623l-1.878,70.22l57.599,-111.393l-69.933,18.862l-11.308,-15.731Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M233.92,124.35l2.559,57.793l24.924,-16.824l-2.022,75.621l62.029,-119.962l-75.313,20.313l-12.177,-16.941Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M225.068,120.083l2.741,61.921l26.705,-18.026l-2.167,81.023l66.46,-128.532l-80.692,21.765l-13.047,-18.151Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M216.216,115.816l2.924,66.049l28.485,-19.228l-2.311,86.424l70.89,-137.1l-86.071,23.216l-13.917,-19.361Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M207.364,111.549l3.107,70.177l30.265,-20.43l-2.455,91.826l75.321,-145.669l-91.451,24.667l-14.787,-20.571Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M198.512,107.282l3.29,74.305l32.045,-21.632l-2.6,97.228l79.752,-154.238l-96.83,26.118l-15.657,-21.781Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M189.66,103.015l3.472,78.433l33.826,-22.833l-2.744,102.628l84.182,-162.806l-102.209,27.569l-16.527,-22.991Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M180.808,98.748l3.655,82.561l35.606,-24.035l-2.888,108.03l88.613,-171.375l-107.59,29.02l-17.396,-24.201Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M171.956,94.48l3.838,86.69l37.386,-25.237l-3.033,113.432l93.044,-179.944l-112.969,30.471l-18.266,-25.412Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M163.104,90.213l4.021,90.818l39.166,-26.439l-3.177,118.834l97.474,-188.513l-118.348,31.922l-19.136,-26.622Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M154.252,85.946l4.203,94.945l40.947,-27.64l-3.321,124.235l101.904,-197.081l-123.727,33.373l-20.006,-27.832Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M145.4,81.679l4.386,99.073l42.727,-28.841l-3.466,129.636l106.336,-205.65l-129.107,34.824l-20.876,-29.042Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M136.548,77.412l4.569,103.201l44.507,-30.043l-3.61,135.038l110.766,-214.219l-134.486,36.275l-21.746,-30.252Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M127.696,73.145l4.752,107.329l46.287,-31.245l-3.755,140.44l115.197,-222.788l-139.866,37.726l-22.615,-31.462Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M118.844,68.878l4.934,111.457l48.068,-32.447l-3.899,145.841l119.628,-231.356l-145.246,39.177l-23.485,-32.672Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M109.992,64.61l5.117,115.586l49.848,-33.649l-4.043,151.243l124.058,-239.925l-150.625,40.628l-24.355,-33.883Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M101.14,60.343l5.3,119.714l51.628,-34.851l-4.188,156.645l128.489,-248.494l-156.004,42.079l-25.225,-35.093Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M92.288,56.076l5.483,123.842l53.409,-36.052l-4.333,162.045l132.919,-257.062l-161.383,43.529l-26.095,-36.302Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M83.436,51.809l5.666,127.97l55.189,-37.254l-4.477,167.447l137.35,-265.631l-166.763,44.98l-26.965,-37.512Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M74.584,47.542l5.848,132.098l56.97,-38.456l-4.622,172.849l141.781,-274.2l-172.143,46.431l-27.834,-38.722Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M65.733,43.275l6.03,136.226l58.75,-39.658l-4.766,178.251l146.211,-282.769l-177.522,47.882l-28.703,-39.932Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M56.881,39.008l6.213,140.354l60.53,-40.86l-4.91,183.652l150.642,-291.337l-182.902,49.333l-29.573,-41.142Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M48.029,34.741l6.396,144.482l62.31,-42.061l-5.055,189.053l155.073,-299.906l-188.281,50.784l-30.443,-42.352Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M39.177,30.474l6.578,148.61l64.091,-43.263l-5.199,194.455l159.503,-308.475l-193.66,52.235l-31.313,-43.562Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M30.325,26.206l6.761,152.739l65.871,-44.465l-5.344,199.856l163.934,-317.043l-199.04,53.686l-32.182,-44.773Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M21.473,21.939l6.944,156.866l67.651,-45.666l-5.488,205.258l168.365,-325.612l-204.42,55.137l-33.052,-45.983Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M12.621,17.672l7.127,160.994l69.431,-46.868l-5.632,210.66l172.795,-334.181l-209.799,56.588l-33.922,-47.193Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
      <path
        d="M3.769,13.405l7.309,165.122l71.212,-48.069l-5.777,216.061l177.226,-342.75l-215.178,58.039l-34.792,-48.403Z"
        style={{ fill: 'none', stroke: '#1de9b6', strokeWidth: '0.75px' }}
      />
    </svg>
  );
}

export default BlobOrigami;
